
import axios from 'axios'
import { api } from '@/assets/config/interface_api.js'
import { setCookie, getCookie, delAllCookie } from '@/assets/js/cookie.js'
import router from '@/router/index.js'
import { allRouter } from '@/router/allRouter'


function permissionInit (cb) {
  var userInfo = JSON.parse(getCookie('userInfo'));
  //获取用户被禁用权限
  axios.get(api.BASEURL + api.rolePermissions, {
    params: {
      role_id: userInfo.role_id,
    }
  }).then(function (res) {
    let data = res.data;
    if (data && data.errno == 0) {
      setCookie('sideInfo', JSON.stringify(data.rst))
      function copy (obj) {//深拷贝
        var newobj = obj.constructor === Array ? [] : {};
        if (typeof obj !== 'object') {
          return;
        }
        for (var i in obj) {
          newobj[i] = typeof obj[i] === 'object' ? copy(obj[i]) : obj[i];
        }
        return newobj
      }
      var arr = copy(allRouter)
      arr.forEach((item) => {
        var brr = item.children;
        function loopEvent (data) {
          data.forEach((item) => {
            if (item.enable != 1) {
              if (item.route) {
                brr = brr.filter((v) => {
                  return v.name != item.route
                })
              } else {
                if (item.child) {
                  loopEvent(item.child)
                }
              }
            } else {
              if (item.child) {
                loopEvent(item.child)
              }
            }
          });
        }
        loopEvent(data.rst)
        item.children = brr;
      })
      var routes = arr;
      router.options.routes = routes;//router.options.routes 不是响应式的
      router.addRoutes(routes)
      cb ? cb() : ''
    } else {
      //4001未登录 4002登录了被挤下来了
      delAllCookie();//清除所有的cookie
      if (data.errno == '4001' || data.errno == '4002') {
        // 未登录
        cb ? cb() : ''
        return;
      }
      cb ? cb() : ''
    }
  }).catch(function (error) {
    cb ? cb() : ''
  });
}

export default permissionInit;


// WEBPACK FOOTER //
// ./src/router/permission.js